import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom'
// import logo from '../../images/Logo.svg'
// import logo3 from '../../images/Lason_Logo.jpg'
// import logo2 from '../../images/site_logo/site_logo_3.svg'
import logo3 from '../../images/site_logo/3.png';
import logo2 from '../../images/site_logo/2.png';
// import logo1 from '../../images/site_logo/1.png';

import MobileMenu from '../MobileMenu/MobileMenu'
import Services from '../../api/service';


const Header2 = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (

        <header className="site_header site_header_2">
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center" style={{height:'120px'}}>
                        <div className="col-xl-3 col-lg-2 col-5">
                            <div className="site_logo">
                                <Link onClick={ClickHandler} className="site_link" to="/">
                                    <img src={logo2} alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template" />
                                    <img src={logo3} alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template" />
                                </Link>
                            </div>
                        </div>

                        {/*<div className="col-xl-3 col-lg-2 col-5 d-flex align-self-start">*/}
                        {/*    <div className="site_logo mt-n2"> /!* Moves slightly upward *!/*/}
                        {/*        <Link onClick={ClickHandler} className="site_link" to="/">*/}
                        {/*            <img*/}
                        {/*                src={logo2}*/}
                        {/*                alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template"*/}
                        {/*                className="img-fluid"*/}
                        {/*            />*/}
                        {/*            <img*/}
                        {/*                src={logo3}*/}
                        {/*                alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template"*/}
                        {/*                className="img-fluid"*/}
                        {/*            />*/}
                        {/*        </Link>*/}
                        {/*    </div>*/}
                        {/*</div>*/}




                        <div className="col-xl-6 col-lg-7 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center"
                                     id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list justify-content-center">
                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="home_submenu"
                                                  role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/about"
                                                  id="home_submenu" role="button" data-bs-toggle="dropdown"
                                                  aria-expanded="false">
                                                About Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/Portfolio"
                                                  id="home_submenu" role="button" data-bs-toggle="dropdown"
                                                  aria-expanded="false">
                                                Portfolio
                                            </Link>
                                        </li>
                                        <li className="dropdown">
                                            <Link
                                                onClick={ClickHandler}
                                                className="nav-link"
                                                to="/service"
                                                id="services_submenu"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                Services
                                            </Link>
                                            <div
                                                className="dropdown-menu mega_menu_wrapper p-3"
                                                aria-labelledby="services_submenu"
                                                style={{
                                                    backgroundColor: '#fff',
                                                    borderRadius: '15px',
                                                    boxShadow: '0 8px 20px rgba(5, 122, 252, 0.15)',
                                                    width: '100%',
                                                    minWidth: '300px',
                                                    border: '1px solid rgba(5, 122, 252, 0.1)'
                                                }}
                                            >
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="megamenu_widget">
                                                                <h3
                                                                    className="megamenu_info_title"
                                                                    style={{
                                                                        color: '#057AFC',
                                                                        fontSize: '18px',
                                                                        fontWeight: 'bold',
                                                                        textAlign: 'center',
                                                                        marginBottom: '15px',
                                                                        position: 'relative',
                                                                        paddingBottom: '10px'
                                                                    }}
                                                                >
                                                                    <Link
                                                                        onClick={ClickHandler}
                                                                        to="/service"
                                                                        style={{
                                                                            textDecoration: 'none',
                                                                            color: '#057AFC'
                                                                        }}
                                                                    >
                                                                        Our Services
                                                                    </Link>
                                                                    <span style={{
                                                                        position: 'absolute',
                                                                        bottom: '0',
                                                                        left: '50%',
                                                                        transform: 'translateX(-50%)',
                                                                        width: '50px',
                                                                        height: '3px',
                                                                        background: '#057AFC',
                                                                        borderRadius: '2px'
                                                                    }}></span>
                                                                </h3>
                                                                <ul
                                                                    className="icon_list unordered_list_block"
                                                                    style={{
                                                                        display: 'grid',
                                                                        gridTemplateColumns: 'repeat(3, 1fr)',
                                                                        gap: '12px',
                                                                        padding: '10px 5px',
                                                                        margin: '0'
                                                                    }}
                                                                >
                                                                    {Services.slice(0, 9).map((service, srv) => (
                                                                        <li key={srv} style={{
                                                                            listStyle: 'none',
                                                                            position: 'relative'
                                                                        }}>
                                                                            {service.title && (
                                                                                <Link
                                                                                    onClick={ClickHandler}
                                                                                    to={`/service-single/${service.slug}`}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        padding: '10px 12px',
                                                                                        color: '#333',
                                                                                        borderRadius: '8px',
                                                                                        textDecoration: 'none',
                                                                                        transition: 'all 0.3s ease',
                                                                                        fontSize: '14px',
                                                                                        fontWeight: '500',
                                                                                        background: '#f8f8f8',
                                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                                                        textAlign: 'center',
                                                                                        position: 'relative',
                                                                                        overflow: 'hidden',
                                                                                        zIndex: '1'
                                                                                    }}
                                                                                    onMouseEnter={(e) => {
                                                                                        e.currentTarget.style.color = '#fff';
                                                                                        e.currentTarget.style.transform = 'translateY(-3px)';
                                                                                        e.currentTarget.style.boxShadow = '0 5px 15px rgba(5, 122, 252, 0.2)';
                                                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #057AFC, #2f92ff)';
                                                                                    }}
                                                                                    onMouseLeave={(e) => {
                                                                                        e.currentTarget.style.color = '#333';
                                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                                                                        e.currentTarget.style.background = '#f8f8f8';
                                                                                    }}
                                                                                >
                                                                                    {service.title}
                                                                                </Link>
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <div style={{marginTop: '15px', textAlign: 'center'}}>
                                                                    <Link
                                                                        onClick={ClickHandler}
                                                                        to="/service"
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            padding: '8px 20px',
                                                                            background: 'linear-gradient(135deg, #057AFC, #2f92ff)',
                                                                            borderRadius: '25px',
                                                                            color: '#fff',
                                                                            fontSize: '14px',
                                                                            fontWeight: '600',
                                                                            textDecoration: 'none',
                                                                            transition: 'all 0.3s ease',
                                                                            boxShadow: '0 4px 10px rgba(5, 122, 252, 0.3)'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(5, 122, 252, 0.4)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                                            e.currentTarget.style.boxShadow = '0 4px 10px rgba(5, 122, 252, 0.3)';
                                                                        }}
                                                                    >
                                                                        View All Services
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/blog"
                                                  id="home_submenu" role="button" data-bs-toggle="dropdown"
                                                  aria-expanded="false">
                                                Blogs
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)}
                                            type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown"
                                            aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} className="btn btn-primary" to="/contact">
                                        <span className="btn_label" data-text="Get Started">Free Consultation</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close"
                                 onClick={() => setMobailState(!mobailActive)}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu  setMobailState={setMobailState}/>
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>

    )
}

export default Header2;